var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationInactiveOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#B3E4EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 16.9998C13.2501 13.272 16.2722 10.25 20 10.25C23.7279 10.25 26.75 13.2721 26.75 17L26.7498 17.0492V17.75C26.7498 19.8731 27.5508 21.8074 28.8684 23.2699C29.0349 23.4547 29.0989 23.71 29.0393 23.9516C28.9797 24.1931 28.8042 24.3893 28.5709 24.4755C27.0269 25.0455 25.4105 25.4659 23.7396 25.7192C23.7465 25.812 23.75 25.9056 23.75 26C23.75 28.0711 22.0711 29.75 20 29.75C17.9289 29.75 16.25 28.0711 16.25 26C16.25 25.9056 16.2535 25.812 16.2604 25.7192C14.5893 25.4659 12.9729 25.0455 11.4288 24.4755C11.1954 24.3893 11.0199 24.1931 10.9603 23.9516C10.9007 23.71 10.9648 23.4547 11.1313 23.2699C12.4488 21.8074 13.2498 19.8731 13.2498 17.75L13.25 16.9998ZM17.7522 25.8993C17.7508 25.9326 17.75 25.9662 17.75 26C17.75 27.2426 18.7574 28.25 20 28.25C21.2427 28.25 22.25 27.2426 22.25 26C22.25 25.9662 22.2493 25.9326 22.2478 25.8992C21.5072 25.9659 20.7574 26 19.9998 26C19.2424 26 18.4927 25.966 17.7522 25.8993Z",
    fill: "#12ABBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationInactiveOpen);
export default __webpack_public_path__ + "static/media/icon-notification-inactive-open.a6c82116942677f928a37644745ff272.svg";
export { ForwardRef as ReactComponent };